import { useEffect } from 'react';
import { Location, History } from 'history';
interface IProps {
  history: History;
  shouldBlockNavigation: (nextLocation: Location) => boolean;
  onBlocked: (location: Location) => void;
}

const NavigationBlocker: React.FC<IProps> = ({ history, shouldBlockNavigation, onBlocked }) => {
  useEffect(() => {
    //@ts-ignore
    const unblock = history.block((location: Location, action: Action) => {
      if (shouldBlockNavigation(location)) {
        onBlocked(location);
        return false;
      }
      return true;
    });
    return () => unblock();
  }, [history, shouldBlockNavigation, onBlocked]);

  return null;
};

export default NavigationBlocker;
